import { render, staticRenderFns } from "./robots-manager.vue?vue&type=template&id=42be05ef&scoped=true&"
import script from "./robots-manager.vue?vue&type=script&lang=js&"
export * from "./robots-manager.vue?vue&type=script&lang=js&"
import style0 from "./robots-manager.vue?vue&type=style&index=0&id=42be05ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42be05ef",
  null
  
)

export default component.exports